import * as Types from '../../graphqlBase.generated';

import { TypedDocumentString } from "~/gql/graphqlBase.generated";
import { baseApiWithGraphql } from '~/services/baseApi';
import type { GraphqlEndpointBuilder } from '~/services/baseApi';
export type CreateProductionCatalogMutationVariables = Types.Exact<{
  input: Types.CreateProductionCatalogInput;
}>;


export type CreateProductionCatalogMutation = { __typename?: 'Mutation', createProductionCatalog: { __typename?: 'ProductionCatalogPayload', catalog?: { __typename?: 'ProductionCatalogData', tenantId: string, productionCatalogId: string, genus: string, series: string, color: string, origin?: Types.ProductionCatalogOrigin | null, status: Types.ProductionCatalogStatus, defaultFarm?: { __typename?: 'ProductionCatalogFarmData', vendorId: string, vendorName: string } | null, alternateFarms: Array<{ __typename?: 'ProductionCatalogFarmData', vendorId: string, vendorName: string }> } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type UpdateProductionCatalogMutationVariables = Types.Exact<{
  input: Types.UpdateProductionCatalogInput;
}>;


export type UpdateProductionCatalogMutation = { __typename?: 'Mutation', updateProductionCatalog: { __typename?: 'ProductionCatalogPayload', catalog?: { __typename?: 'ProductionCatalogData', tenantId: string, productionCatalogId: string, genus: string, series: string, color: string, origin?: Types.ProductionCatalogOrigin | null, status: Types.ProductionCatalogStatus, defaultFarm?: { __typename?: 'ProductionCatalogFarmData', vendorId: string, vendorName: string } | null, alternateFarms: Array<{ __typename?: 'ProductionCatalogFarmData', vendorId: string, vendorName: string }> } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type ChangeProductionCatalogStatusMutationVariables = Types.Exact<{
  input: Types.ChangeProductionCatalogStatusInput;
}>;


export type ChangeProductionCatalogStatusMutation = { __typename?: 'Mutation', changeProductionCatalogStatus: { __typename?: 'ProductionCatalogPayload', catalog?: { __typename?: 'ProductionCatalogData', tenantId: string, productionCatalogId: string, genus: string, series: string, color: string, origin?: Types.ProductionCatalogOrigin | null, status: Types.ProductionCatalogStatus, defaultFarm?: { __typename?: 'ProductionCatalogFarmData', vendorId: string, vendorName: string } | null, alternateFarms: Array<{ __typename?: 'ProductionCatalogFarmData', vendorId: string, vendorName: string }> } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type CombineProductionCatalogsMutationVariables = Types.Exact<{
  input: Types.CombineProductionCatalogsInput;
}>;


export type CombineProductionCatalogsMutation = { __typename?: 'Mutation', combineProductionCatalogs: { __typename?: 'CombineProductionCatalogsPayload', survivorId?: string | null, loserId?: string | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type RevertProductionCatalogCombineMutationVariables = Types.Exact<{
  input: Types.RevertProductionCatalogCombineInput;
}>;


export type RevertProductionCatalogCombineMutation = { __typename?: 'Mutation', revertProductionCatalogCombine: { __typename?: 'RevertProductionCatalogCombinePayload', survivorId?: string | null, loserId?: string | null, forecastSalesItemIdsNotRestored?: Array<string> | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };


export const CreateProductionCatalogDocument = new TypedDocumentString(`
    mutation CreateProductionCatalog($input: CreateProductionCatalogInput!) {
  createProductionCatalog(input: $input) {
    catalog {
      ...ProductionCatalogData
    }
    errors {
      code
      message
    }
  }
}
    fragment ProductionCatalogData on ProductionCatalogData {
  tenantId
  productionCatalogId
  genus
  series
  color
  origin
  defaultFarm {
    vendorId
    vendorName
  }
  alternateFarms {
    vendorId
    vendorName
  }
  status
}`);
export const UpdateProductionCatalogDocument = new TypedDocumentString(`
    mutation UpdateProductionCatalog($input: UpdateProductionCatalogInput!) {
  updateProductionCatalog(input: $input) {
    catalog {
      ...ProductionCatalogData
    }
    errors {
      code
      message
    }
  }
}
    fragment ProductionCatalogData on ProductionCatalogData {
  tenantId
  productionCatalogId
  genus
  series
  color
  origin
  defaultFarm {
    vendorId
    vendorName
  }
  alternateFarms {
    vendorId
    vendorName
  }
  status
}`);
export const ChangeProductionCatalogStatusDocument = new TypedDocumentString(`
    mutation ChangeProductionCatalogStatus($input: ChangeProductionCatalogStatusInput!) {
  changeProductionCatalogStatus(input: $input) {
    catalog {
      ...ProductionCatalogData
    }
    errors {
      code
      message
    }
  }
}
    fragment ProductionCatalogData on ProductionCatalogData {
  tenantId
  productionCatalogId
  genus
  series
  color
  origin
  defaultFarm {
    vendorId
    vendorName
  }
  alternateFarms {
    vendorId
    vendorName
  }
  status
}`);
export const CombineProductionCatalogsDocument = new TypedDocumentString(`
    mutation CombineProductionCatalogs($input: CombineProductionCatalogsInput!) {
  combineProductionCatalogs(input: $input) {
    survivorId
    loserId
    errors {
      code
      message
    }
  }
}
    `);
export const RevertProductionCatalogCombineDocument = new TypedDocumentString(`
    mutation RevertProductionCatalogCombine($input: RevertProductionCatalogCombineInput!) {
  revertProductionCatalogCombine(input: $input) {
    survivorId
    loserId
    forecastSalesItemIdsNotRestored
    errors {
      code
      message
    }
  }
}
    `);
const injectedRtkApiEndpoints = (build: GraphqlEndpointBuilder) => ({
    CreateProductionCatalog: build.mutation<CreateProductionCatalogMutation, CreateProductionCatalogMutationVariables>({
      query: (variables) => ({ document: CreateProductionCatalogDocument, variables })
    }),
    UpdateProductionCatalog: build.mutation<UpdateProductionCatalogMutation, UpdateProductionCatalogMutationVariables>({
      query: (variables) => ({ document: UpdateProductionCatalogDocument, variables })
    }),
    ChangeProductionCatalogStatus: build.mutation<ChangeProductionCatalogStatusMutation, ChangeProductionCatalogStatusMutationVariables>({
      query: (variables) => ({ document: ChangeProductionCatalogStatusDocument, variables })
    }),
    CombineProductionCatalogs: build.mutation<CombineProductionCatalogsMutation, CombineProductionCatalogsMutationVariables>({
      query: (variables) => ({ document: CombineProductionCatalogsDocument, variables })
    }),
    RevertProductionCatalogCombine: build.mutation<RevertProductionCatalogCombineMutation, RevertProductionCatalogCombineMutationVariables>({
      query: (variables) => ({ document: RevertProductionCatalogCombineDocument, variables })
    }),
});

const injectedRtkApi = baseApiWithGraphql.injectEndpoints({ endpoints: injectedRtkApiEndpoints });

export type GeneratedEndpointDefinitions = ReturnType<typeof injectedRtkApiEndpoints>;

export { injectedRtkApi as api };
export const { useCreateProductionCatalogMutation, useUpdateProductionCatalogMutation, useChangeProductionCatalogStatusMutation, useCombineProductionCatalogsMutation, useRevertProductionCatalogCombineMutation } = injectedRtkApi;
